
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ArrowLeft } from 'lucide-react';
import Footer from './Footer';


interface PageLayoutProps {
  title: string;
  description: string;
  children: React.ReactNode;
  ogImage?: string;
}



const PageLayout: React.FC<PageLayoutProps> = ({ 
  title, 
  description, 
  children,
  ogImage = "/bucket/avatar.png"
}) => {
  const navigate = useNavigate();
  const location = useLocation();

 
  
  return (
    <> 
      <div className="min-h-screen flex flex-col">
        <main className="flex-grow gradient-bg">
          <div className="container mx-auto px-4 py-8">
            <button
              type="button"
              onClick={() => navigate('/')}
              className="mb-6 flex items-center gap-2 text-blue-600 hover:text-blue-800 transition-colors"
              aria-label="Retour"
            >
              <ArrowLeft size={20} />
              <span>Retour</span>
            </button>
            
            <h1 className="text-3xl lg:text-4xl font-bold mb-4">{title}</h1>
            <p className="text-lg text-gray-600 mb-8">{description}</p>
            
            <div className="">
              {children}
            </div>
          </div>
        </main>
      </div>
        <Footer />
    </>
  );
};

export default PageLayout;
